import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";
import React from "react";
import styled from "styled-components";
import { TestContext } from "./TestContext";
import { TestingConstants } from "./TestingConstants";

export const TestResult = ({ executableId }: { executableId: string }) => {
    const testContext = React.useContext(TestContext);
    if (!testContext) return null;

    const currentTestItem = testContext.findItem(executableId);

    return (
        <TestResultRender
            isError={testContext?.isError || (!!currentTestItem && !currentTestItem.result)}
            data-testid="test-result"
        >
            <TestResultLabelRender className="test-result-label">Result</TestResultLabelRender>
            <TestResultValueRender className="test-result-value">
                {currentTestItem?.result || "No Result"}
            </TestResultValueRender>
        </TestResultRender>
    );
};

const TestResultRender = styled.div<{ isError: boolean }>`
    margin-top: 20px;

    display: flex;
    border-radius: 4px;
    ${(props) =>
        props.isError
            ? `
                border: 1px solid ${TestingConstants.BORDER_FAIL};

                .test-result-label {
                    background: ${TestingConstants.BACKGROUND_FAIL};
                }

                .test-result-value {
                    color: ${UIStyleConstants.RED_COLOR};
                }
            `
            : `
                border: 1px solid ${TestingConstants.BORDER_SUCCESS};
                .test-result-label {
                    background: ${TestingConstants.BACKGROUND_SUCCESS};
                }

                .test-result-value {
                    color: ${UIStyleConstants.GREEN_VERY_LIGHT_COLOR};
                }
            `}
`;

const TestResultValueRender = styled.div`
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;

    padding: 8px 12px;
`;

const TestResultLabelRender = styled.div`
  //styleName: text/Inter Medium 14px;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;

  padding: 8px 12px;

  color ${UIStyleConstants.GRAY_COLOR};;
`;
